import sortBy from "lodash/sortBy";
import * as React from "react";
import { JSX } from "react";
import { FilterItemsGroupOperation } from "@app/resource-filters/common";
import { ResourceType } from "@app/resources";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { FilterSetService } from "@app/resource-filters/filter-sets/filterSetService";
import { FilterSet } from "@app/resource-filters/filter-sets/filterSet";
import { ResourceFilterSet } from "@app/resource-filters/filter-sets/resourceFilterSet";
import { QESButton } from "@app/shared/qes-standards/Button";

const filterSetService = new FilterSetService();

/** As the filter set controls are embedded in the creation component, this is called when a user loads a filter set. */

interface SavedFiltersProps {
  activeFilterSet: ResourceFilterSet;
  onFilterSetChange: (filterSet: FilterSet) => void;
  resourceType: ResourceType;
}

/** Renders the view of all current saved filter sets. Designed to be embedded in CreateFilter. */
function SavedFilters({ activeFilterSet, onFilterSetChange, resourceType }: SavedFiltersProps): JSX.Element {
  const [name, setName] = React.useState(activeFilterSet && activeFilterSet.name || "");
  const [filterSets, setFilterSets] = React.useState<FilterSet[]>([]);

  React.useEffect(() => {
    async function loadFilterSets() {
      const sets = await filterSetService.getFilterSets(resourceType);
      setFilterSets(sets);
    }

    loadFilterSets();
  }, [resourceType]);

  const handleSaveClick = async () => {
    await filterSetService.create({
      filterGroups: [...(activeFilterSet.filterGroups || []), ...(activeFilterSet.pendingChanges || [])],
      groupsOperation: activeFilterSet.groupsOperation || FilterItemsGroupOperation.LogicalAnd,
      name,
      targetResourceType: activeFilterSet.targetResourceType,
    });

    const sets = await filterSetService.getFilterSets(resourceType);
    setFilterSets(sets);
  };

  const handleDeleteClick = async (e: React.MouseEvent<HTMLDivElement>, filterSetId: number) => {
    e.stopPropagation();
    await filterSetService.delete(filterSetId);

    const sets = await filterSetService.getFilterSets(resourceType);
    setFilterSets(sets);
  };

  return (
    <>
      {filterSets.length > 0 ? (
        sortBy(filterSets, [(fs: FilterSet) => fs.name]).map((fs) => (
          <li key={fs.filterSetId} className="filter-item branch-item clearfix" onClick={() => onFilterSetChange(fs)}>
            <div className="pull-right" onClick={(e) => handleDeleteClick(e, fs.filterSetId)}>
              <QesIcon iconName={QesIcons.TrashV1} description="Delete saved filter" className="delete-saved-filter align-text-top" />
            </div>
            <div className="pull-left" style={{ textTransform: "none" }}>
              {fs.name}
            </div>
          </li>
        ))
      ) : (
        <li className="filter-item branch-item clearfix">
          <div className="text-muted">No saved filters...</div>
        </li>
      )}

      <li className="filter-item branch-item clearfix">
        <div>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </li>

      <li className="leaf-filter-save" >
        <QESButton qesTestId="saved-filters_save-filters" onClick={handleSaveClick}>
          Save Filters
        </QESButton>
      </li>
    </>
  );
}

export { SavedFilters };
